import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import AuthLayout from '../../features/auth/AuthLayout';
import LogoHeader from '../../components/LogoHeader';
import LocaleSwitcher from '../../components/LocaleSwitcher';
import AuthCard from '../../features/auth/AuthCard';
import LoginForm from '@/features/auth/LoginForm';
import { useUser } from '@/providers/UserProvider';
import { sanitizePostLoginRedirect } from '@/utils/postLoginRedirect';

const Login: React.FC = () => {
  const { userData, loading } = useUser();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-600">{t('app.loading')}</div>
      </div>
    );
  }

  if (userData) {
    const target = sanitizePostLoginRedirect(searchParams.get('redirect'), {
      canAccessAdmin: userData.can_access_admin,
    });
    return <Navigate to={target} replace />;
  }

  return (
    <main>
      <AuthLayout>
        <div className="w-full max-w-md flex justify-end mb-2 px-1">
          <LocaleSwitcher />
        </div>
        <LogoHeader />
        <AuthCard>
          <h1 className="text-center text-2xl font-semibold text-gray-900">
            {t('auth.welcome_back')}
          </h1>
          <p className="text-center text-gray-500 mb-6">
            {t('auth.subtitle')}
          </p>
          <LoginForm />
          <p className="mt-4 text-center text-sm text-gray-600">
            {t('auth.no_account')}{' '}
            <a
              href="/register"
              className="font-medium text-blue-700 hover:underline"
            >
              {t('auth.sign_up')}
            </a>
          </p>
        </AuthCard>
      </AuthLayout>
    </main>
  );
};

export default Login;
